// extracted by mini-css-extract-plugin
export var closeButton = "_pj-2";
export var closeButtonIcon = "_pj-3";
export var lightboxContent = "_pj-1";
export var lightboxOverlay = "_pj-0";